import qrcode from "qrcode-generator";

/**
 * Referral helpers (#1571, D417): the join link and its QR code. Pure, no
 * network. The QR is made here, in the browser, from the link and nothing else.
 */

/** `https://<origin>/join/<code>`: the one string the QR encodes and the card shows. */
export function joinLink(origin, code) {
  return `${String(origin).replace(/\/+$/, "")}/join/${code}`;
}

/** Error-correction M: survives a smudge, and a link this short stays a small, easy-to-scan code. */
const ERROR_CORRECTION = "M";

/**
 * The dark modules of the QR code for `text` as rows of booleans. The smallest
 * version that fits is chosen by the library (typeNumber 0).
 */
export function qrMatrix(text) {
  const qr = qrcode(0, ERROR_CORRECTION);
  qr.addData(String(text));
  qr.make();
  const n = qr.getModuleCount();
  const rows = [];
  for (let r = 0; r < n; r++) {
    const row = [];
    for (let c = 0; c < n; c++) row.push(qr.isDark(r, c));
    rows.push(row);
  }
  return rows;
}

/** An SVG path (`M x y h1 v1 h-1 z` per dark module) in module units, for a viewBox of `n` + the quiet zone. */
export function qrPath(matrix, quiet = 2) {
  let d = "";
  matrix.forEach((row, r) => {
    row.forEach((dark, c) => {
      if (dark) d += `M${c + quiet} ${r + quiet}h1v1h-1z`;
    });
  });
  return d;
}

export function friendsLine(n) {
  return n === 1 ? "1 friend has joined" : `${n} friends have joined`;
}
